// extracted by mini-css-extract-plugin
module.exports = {"worker-container":"worker-tab-title_worker-container_27bsX","title":"worker-tab-title_title_rggTb"};